module.exports = __webpack_public_path__ + "media/images/pc/fp/fp-image@2x-5db1bbd0a3b49e94e3ae98f876889d05.png";